module.exports = __webpack_public_path__ + "static/media/accumulated.97c2a9b1.png";